export {
  setArrivalDate,
  setIsArrivalDateKnown,
  setPlanningStage,
} from 'registry/actions'

export const SET_USER_RESPONSE = 'SET_USER_RESPONSE'
export const setUserResponse = (data) => ({ type: SET_USER_RESPONSE, data })
